import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError, BehaviorSubject } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProgramacionesMantenimientoService {

  private apiUrl = environment.apiUrl + '/api'; // Reemplaza con la URL de tu API

  constructor(private http: HttpClient) { }

  agregarProgramacion(seleccionadas: any[]): Observable<any> {
    console.log(this.apiUrl);
    return this.http.post(`${this.apiUrl}/programacion-mantenimientos`, seleccionadas);
  }

 getProgramaciones(
  datosConsulta?: {
    estado?: number | string;
    fechaInicial?: string;
    fechaFinal?: string;
    placa?: string;
    plan?: number | string;
  }
): Observable<ProgramacionesResponse> {
  return this.http.get<ProgramacionesResponse>(
    `${this.apiUrl}/programacion-mantenimientos`,
    {
      params: {
        ...(datosConsulta?.estado != null
          ? { estado: String(datosConsulta.estado) }
          : {}),
        ...(datosConsulta?.fechaInicial
          ? { fechaInicial: datosConsulta.fechaInicial }
          : {}),
        ...(datosConsulta?.fechaFinal
          ? { fechaFinal: datosConsulta.fechaFinal }
          : {}),
        ...(datosConsulta?.placa
          ? { placa: datosConsulta.placa }
          : {}),
        ...(datosConsulta?.plan
          ? { plan: String(datosConsulta.plan) }
          : {})
      }
    }
  );
}

  eliminarProgramacion(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/programacion-mantenimientos/${id}`);
  }

  actualizarProgramacion(id: number, datos: any) {
  return this.http.put(
    `${this.apiUrl}/programacion-mantenimientos/${id}`,
    datos
  );
}

  actualizarEstadoProgramacion(
  id: number,
  estado: { estado_programacion_id: number }
): Observable<any> {
  return this.http.put(
    `${this.apiUrl}/programacion-mantenimientos/${id}`,
    estado
  );
}

  consultarActividadPorPlan(planId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/programacion-mantenimientos/actividades/${planId}`);
  }
  


}

export interface ProgramacionMantenimiento {
  id: number;
  plan_mantenimiento_id: number;
  plan_mantenimiento_actividad_id: number;
  placa: string;
  actividad_id: number;

  km_base: string | null;
  km_actual: string | null;
  proximo_km: string | null;
  alerta_km: string | null;
  frecuencia_km: number | null;
  frecuencia_meses: number | null;
  fecha_base: string | null;
  proxima_fecha: string | null;
  alerta_dias: number | null;
  fecha_alerta: string | null;
  estado: string;
  fecha_programacion: string;
  usuario_id: number;
  createdAt: string;
  updatedAt: string;

  // Relaciones anidadas (include del backend)
  PlanMantenimientoActividad?: {
    id: number;
    tipoControl?: string;
    servicioRealizado?: {
      tipo_de_mantenimiento?: string;
      sistema?: string;
    };
    planMantenimiento?: {
      codigo?: string;
      nombre?: string;
    };
  };
  VehicleModel?: {
    placa?: string;
    interno?: string | number;
    kilometraje?: number | null;
  };
}

export interface ProgramacionesResponse {
  codigo: number;
  mensaje: string;
  data: ProgramacionMantenimiento[];
}